import EpisodeOfCareItem from './EpisodeOfCareItem';

export default EpisodeOfCareItem;
